// extracted by mini-css-extract-plugin
var _1 = "_4o72P_CMOZpPcwBPasWX";
var _2 = "J_ScTsJq3sUoIKTedV9V";
export { _1 as "alert", _2 as "indicator" }
export default { "alert": _1, "indicator": _2 }
